import { c as convert } from './convert-053e536c.js';



export default convert;



//////////////////
// WEBPACK FOOTER
// ./node_modules/rtl-css-js/dist/esm/index.js
// module id = 159
// module chunks = 0